import { Routes, RouterModule } from '@angular/router';
import { DetalheCursoComponent } from './detalhe-curso.component';


export const DETALHE_CURSO_ROUTER: Routes = [
  {
    path: 'pos-graduacao/:curso',
    component: DetalheCursoComponent,
    children: [
      {
        path: '',
        redirectTo: 'sobre-o-programa',
        pathMatch: 'full',
      }
    ],
  },
];

export const DetalheCursoRouter = RouterModule.forChild(DETALHE_CURSO_ROUTER);
